<div class="flex justify-center items-center gap-6 my-3">
    <div class="border border-gray-300 dark:border-gray-700 p-4 rounded-md">
        <h1 class=" text-3xl">Login to SampleStudio</h1>
        <p class=" text-gray-400 mb-4">You need to login with DEP to use SampleStudio</p>
        <div class="flex flex-col items-center gap-5">
            <a [href]="this.depURL">
                <p-button label="Login with DEP"></p-button>
            </a>
            @if (this.depTestURL) {
                <a [href]="this.depTestURL">
                    <p-button label="Login with DEP (Test Account)"></p-button>
                </a>
            }
        </div>
    </div>
</div>